module.exports = __webpack_public_path__ + "static/media/zh.bc66d14c.svg";